/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Flow_Chip_1Inputs */

const en_services_flow_chip_1 = /** @type {(inputs: Services_Flow_Chip_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inbox`)
};

const lv_services_flow_chip_1 = /** @type {(inputs: Services_Flow_Chip_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pastkaste`)
};

/**
* | output |
* | --- |
* | "Inbox" |
*
* @param {Services_Flow_Chip_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_flow_chip_1 = /** @type {((inputs?: Services_Flow_Chip_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Flow_Chip_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_flow_chip_1(inputs)
	return en_services_flow_chip_1(inputs)
});